
const UserProfile = () => {
  return (
    <div className="register">
      <div className="block md:hidden">
        <button className="avatar">

        </button>
      </div>
      <div className="hidden md:block">
      </div>
    </div>
  );
};

export default UserProfile;
